export const handleState = {
    CLOSE: 'close',
    CANCEL: 'cancel',
    CONFIRM: 'confirm',
    TIMER: 'timer',
    BACKDROP: 'backdrop',
    ESC: 'esc',
} as const;

export const langArr = [
    'ko',
    'en',
    'ar',
    'zh',
    'id',
    'ja',
    'ru',
    'th',
    'vi',
] as const;

export const modalPosition = [
    'top-start',
    'top',
    'top-end',
    'center-start',
    'center',
    'center-end',
    'bottom-start',
    'bottom',
    'bottom-end',
] as const;
